import axios from 'axios'

const api = axios.create({
  baseURL: '/api/designs'
})

export const designs = {
  async create (design) {
    const resp = await api.post('/', design)
    return resp.data
  },

  async update (id, design) {
    await api.put(`/${id}`, design)
  },

  async get (id) {
    const resp = await api.get(`/${id}`)
    return resp.data
  }
}

export async function pdf (design) {
  const resp = await axios.post('/api/pdf', design, { responseType: 'arraybuffer' })
  return resp.data
}



// WEBPACK FOOTER //
// ./src/client/lib/api.js